import { render, staticRenderFns } from "./UserAnalyzes.vue?vue&type=template&id=6e96f387&scoped=true&"
import script from "./UserAnalyzes.vue?vue&type=script&lang=js&"
export * from "./UserAnalyzes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e96f387",
  null
  
)

export default component.exports